var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTypeWater(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#77AADD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0125 8C16.6125 7.36875 17 7 17 7C17.1363 7.45375 17.2925 7.885 17.4638 8.2975C18.4788 10.73 20.055 12.485 21.46 14.0475C23.0975 15.87 24.5 17.4312 24.5 19.5C24.5 21.4891 23.7098 23.3968 22.3033 24.8033C20.8968 26.2098 18.9891 27 17 27C15.0109 27 13.1032 26.2098 11.6967 24.8033C10.2902 23.3968 9.5 21.4891 9.5 19.5C9.5 15.335 13.975 10.1463 16.0125 8ZM16.5288 9.27625C15.726 10.1449 14.9631 11.0496 14.2425 11.9875C13.335 13.175 12.4475 14.4975 11.7925 15.825C11.13 17.1663 10.75 18.4225 10.75 19.5C10.75 21.1576 11.4085 22.7473 12.5806 23.9194C13.7527 25.0915 15.3424 25.75 17 25.75C18.6576 25.75 20.2473 25.0915 21.4194 23.9194C22.5915 22.7473 23.25 21.1576 23.25 19.5C23.25 17.9987 22.255 16.8038 20.5238 14.875L20.4862 14.835C19.1875 13.3875 17.625 11.65 16.5288 9.275V9.27625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6912 16.72C13.7162 14.6687 14.8375 13.2787 15.3075 12.8075L16.1925 13.6925C15.83 14.055 14.7825 15.3312 13.8087 17.28L12.6912 16.72Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeWater);
export default __webpack_public_path__ + "static/media/TypeWater.fb0e6a856c279d1b4ba599bed44107c8.svg";
export { ForwardRef as ReactComponent };